/**
 * 递归获取对象中指定 key 的所有值
 * @param data - 要搜索的数据对象或数组
 * @param key - 要搜索的键名
 * @returns string[] - 找到的所有值数组
 */
export function getAllCodes(data: any, key: string = 'authCode'): string[] {
  const codes: string[] = []

  function traverse(item: any) {
    if (!item || typeof item !== 'object' || item.hidden) {
      return
    }

    // 遍历对象的所有属性
    Object.entries(item).forEach(([k, v]) => {
      // 如果找到匹配的 key
      if (k === key && typeof v === 'string') {
        codes.push(v)
      }
      // 如果值是对象或数组，继续递归
      if (v && typeof v === 'object') {
        traverse(v)
      }
    })
  }

  // 处理输入可能是数组的情况
  if (Array.isArray(data)) {
    data.forEach((item) => traverse(item))
  } else {
    traverse(data)
  }

  return codes
}
